/**
 * The global quick capture: hotkey C or the command palette, from anywhere in the app. The
 * dialog opens with the cursor in the field — thought to saved item stays under five seconds.
 */
import { useEffect, useState } from "react";

import { api, type Space } from "../../api";
import { Dialog } from "../../components/Dialog";
import { SkeletonText } from "../../components/Skeleton";
import { useToast } from "../../components/toast";
import { CaptureComposer } from "./CaptureComposer";

export function QuickCaptureDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const showToast = useToast();
  const [spaces, setSpaces] = useState<Space[] | null>(null);

  useEffect(() => {
    if (open && spaces === null) {
      void api.spaces().then(setSpaces);
    }
  }, [open, spaces]);

  return (
    <Dialog open={open} title="Snabbfångst" subtitle="Hamnar i Strömmen" onClose={onClose}>
      {spaces === null ? (
        <SkeletonText lines={3} />
      ) : (
        <CaptureComposer
          spaces={spaces}
          autoFocus
          onCreated={() => {
            onClose();
            showToast({ message: "Fångat — ligger i Strömmen." });
          }}
        />
      )}
    </Dialog>
  );
}
